<template>
  <v-container fluid pa-0 ma-0 class="user-select-none">
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 toolbar-padding"
                 style="z-index: 3"
                 color="white" flat fixed app>

        <v-tabs v-model="activeTab" slider-color="#4a4a4a" mandatory height="56px">
          <v-tab :ripple="false" href="#Home" class="tab mr-3">
            <h1 class="display-4">&nbsp;&nbsp;&nbsp;홈&nbsp;&nbsp;&nbsp;</h1>
          </v-tab>

          <v-tab :ripple="false" href="#Community" class="tab mr-3">
            <h1 class="display-4">커뮤니티</h1>
          </v-tab>

          <!-- TODO: slider 너비가... 배지까지 포함한 너비가 됩니다... 조정필요 -->
          <v-tabs-slider color="#4a4a4a" style="height: 3px; border-top-left-radius: 24px; border-top-right-radius: 24px;"></v-tabs-slider>
        </v-tabs>

        <v-spacer></v-spacer>

<!--        <v-badge overlap class="badge-position">-->
<!--          <template v-slot:badge v-if="notificationsUpdatedCnt">-->
<!--            <span>{{ notificationsUpdatedCnt }}</span>-->
<!--          </template>-->
<!--          <v-btn class="ma-0" flat icon :loading="notificationLoading" :disabled="notificationLoading" @click="onClickNotifications">-->
<!--            <v-icon :color="notificationsUpdatedCnt > 0 ? '#ec2f54' : '#9b9b9b' ">$vuetify.icons.notification</v-icon>-->
<!--          </v-btn>-->
<!--        </v-badge>-->

        <v-btn class="ma-0" flat icon @click="onClickToolbarIcon(activeTab)">
          <v-badge overlap class="badge-dot" v-if="activeTab === 'Home'">
            <template v-slot:badge v-if="notificationsUpdatedCnt"><span></span></template>
            <v-icon color="#a9a9af" size="32px">$vuetify.icons.menuHamburger</v-icon>
          </v-badge>
          <v-icon v-else color="#a9a9af" size="32px">$vuetify.icons.search</v-icon>
        </v-btn>
      </v-toolbar>

      <v-flex xs12 class="pa-0 ma-0 fill-height">
        <v-tabs-items v-model="activeTab" :touchless="isSlide">
          <v-tab-item value="Home" lazy>
            <TabHome :isActive="activeTab === 'Home'" />
          </v-tab-item>

          <v-tab-item value="Community" lazy>
            <TabCommunity :isActive="activeTab === 'Community'" />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  // import Today from '@/views/HomeTabs/Today';
  // import Subscription from '@/views/HomeTabs/Subscription';
  import TabHome from '@/views/HomeTabs/Home';
  import TabCommunity from '@/views/HomeTabs/Community';
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'Home',
    components: { TabHome, TabCommunity },
    computed: {
      ...mapGetters([ 'subscriptionsClicked' ]),
      ...mapGetters('user', [ 'token' ]),
      ...mapGetters('home', [ 'notificationsUpdatedCnt' ]),
    },
    data () {
      return {
        time: parseInt(new Date().getTime() / 1000),
        isSlide: false,
        activeTab: null,
        scrollY: 0, // 툴바 그림자 때문에 달아놨음 ...
        notificationLoading: false,
      };
    },
    created () {
      if (typeof this.$route.query.to === 'string') {
        this.activeTab = this.$route.query.to;
      }
      if (this.token) {
        this.selectNotificationsUpdatedCnt();
      }
      this.$eventBus.$on('touchCancel', (flag) => {
        this.isSlide = flag;
      });
      // window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      // window.removeEventListener('scroll', this.getScrollY);
    },
    watch: {
      // activeTab (tabValue, oldTab) {
      //   if (oldTab) {
      //     if (tabValue === 'Community' && this.token === '') {
      //       this.$router.push({
      //         name: 'SocialLogin',
      //         query: {redirect: this.$route.fullPath},
      //       });
      //     } else {
      //       this.$router.push({
      //         name: 'Home',
      //         query: { to: tabValue }
      //       });
      //     }
      //   }
      // },
      '$route.query' (query) {
        // console.log(query.to);
        this.activeTab = typeof query.to === 'string' ? query.to : 'Home';
      }
    },
    methods: {
      ...mapActions([ 'toggleDrawer' ]),
      ...mapActions('home', [ 'selectNotificationsUpdatedCnt' ]),
      ...mapMutations([ 'CLICK_SUBSCRIPTION_TAB' ]),
      getScrollY () {
        this.scrollY = window.scrollY;
      },
      onClickToolbarIcon (tab) {
        if (tab === 'Community') {
          this.$router.push({ name: 'SearchCommunity' });
        } else {
          this.toggleDrawer(true);
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .user-select-none {
    user-select: none;
  }

  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.badge-position .v-badge__badge {
    top: 6px;
    right: 18px;
    width: auto;
    height: 14px;
    padding: 0 5px;
    border-radius: 8.5px;

    font-size: 10px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: -0.2px;
  }
  /deep/.tab > a {
    padding-left: 0;
    padding-right: 0;
    color: #4a4a4a;
    /*opacity: 1;*/
  }
  /deep/.badge-dot .v-badge__badge {
    display: block;
    box-sizing: content-box;
    width: 6px;
    height: 6px;
    border: 2px solid white !important;
    top: 2px;
    right: 0;
  }
</style>
